import React from 'react';
import tableHelpers from '../helpers/TableHelpers.js'
import RichTable from '../components/richTable/RichTable.jsx'

function PlanScorecard(props) {

    function getScorecardArray() {

        return [
            {
                name: 'Annual Profit',
                result: getPeriodResult("yearly", "avgResult"),
                spyResult: getPeriodResult("yearly", "avgResultSpy"),
                format: 'percent'
            },
            {
                name: 'Profitable Months',
                result: getPeriodResult("monthly", "winningPercentage"),
                spyResult: getPeriodResult("monthly", "spyWinningPercentage"),
                format: 'percent'
            },
            {
                name: 'Avg Daily Volatility',
                result: getPeriodResult("daily", "avgVolatility"),
                spyResult: getPeriodResult("daily", "avgSpyVolatility"),
                format: 'percent'
            },
            {
                name: 'Sharpe',
                result: getPeriodResult("monthly", "sharpeRatio"),
                spyResult: null,
                format: 'decimal'
            },
            {
                name: 'Max Drawdown',
                result: getPeriodResult("daily", "maxDrawdown"),
                spyResult: getPeriodResult("daily", "maxSpyDrawdown"),
                format: 'percent'
            },
            {
                name: 'Avg Pullback (over 5%)',
                result: getPeriodResult("daily", "avgDrawdown"),
                spyResult: getPeriodResult("daily", "avgDrawdownSpy"),
                format: 'percent'
            },
            {
                name: 'Pullback Count (over 5%)',
                result: getPeriodResult("daily", "totalDrawdowns"),
                spyResult: getPeriodResult("daily", "totalSpyDrawdowns"),
                format: 'int'
            },
            {
                name: 'Exposure over 100%',
                result: getPeriodResult("daily", "exposureOver100") / getPeriodResult("daily", "totalPeriods") * 100,
                spyResult: getPeriodResult("daily", ""),
                format: 'percent'
            },
            {
                name: 'Exposure over 200%',
                result: getPeriodResult("daily", "exposureOver200") / getPeriodResult("daily", "totalPeriods") * 100,
                spyResult: getPeriodResult("daily", ""),
                format: 'percent'
            },
            {
                name: 'Worst Year',
                result: getPeriodResult("yearly", "worst"),
                spyResult: getPeriodResult("yearly", "worstSpy"),
                format: 'percent'
            },
            {
                name: 'Monthly Profit',
                result: getPeriodResult("monthly", "avgResult"),
                spyResult: getPeriodResult("monthly", "avgResultSpy"),
                format: 'percent'
            },
            {
                name: 'Out of Money',
                result: getResult("overExtendedCount"),
                spyResult: 0,
                format: 'int'
            },
        ];
    }

    function dynamicFormatter(cell, row) {
        if (row.format === 'int')
            return tableHelpers.intFormatter(cell, row);
        else if (row.format === 'decimal')
            return tableHelpers.decimalFormatter(cell, row);
        else
            return tableHelpers.percentFormatter(cell, row);
    }

    function getPeriodResult(timeframe, key) {
        return (props.backtestResults && props.backtestResults.periodSummaries && props.backtestResults.periodSummaries[timeframe] && props.backtestResults.periodSummaries[timeframe][key]) ?
            props.backtestResults.periodSummaries[timeframe][key] : 0;
    }

    function getResult(key) {
        return (props.backtestResults && props.backtestResults[key]) ?
            props.backtestResults[key] : 0;
    }

    const returnMapper = [
        { title: 'Category', field: 'name' },
        { title: 'S&P 500', field: 'spyResult', formatter: dynamicFormatter },
        { title: 'Plan', field: 'result', formatter: dynamicFormatter },
    ]

    return (
        <>
            <div style={{ width: '85%' }}>
                <RichTable data={getScorecardArray()} mappers={returnMapper} className="table-striped table-hover table-condensed" />
            </div>
        </>
    );
}

export default PlanScorecard; 